import React, { useEffect } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import MainTitle from 'on_web/components/shared/Common/MainTitle';
import SplashScreen from 'on_web/components/shared/SplashScreen/SplashScreen';

import { useTranslation } from 'react-i18next';
import { introScreensTimeout } from 'on_web/helpers/constants';

export default function EnvironmentIntro(props) {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (props.onWelcome) {
        props.onWelcome();
      }
    }, introScreensTimeout);
    return () => clearTimeout(timer);
  });

  const { t } = useTranslation();
  return (
    <div>
      <Header />
      <SplashScreen>
        <MainTitle
          text={t(
            'onboarding.environmentSection.environmentIntro.mainTitleText'
          )}
          animate={true}
        ></MainTitle>
      </SplashScreen>
    </div>
  );
}
